module.exports = __webpack_public_path__ + "media/images/products/retailers-product-3-newsletters-49830f3a69edabdf8b4c84057ea09a60.jpg";